import React, { useState, useEffect } from "react";
import { TextField, Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { loginUser } from "../redux/asyncThunk/userActions";
import { useDispatch, useSelector } from "react-redux";
import { userSlice } from "../redux/user/userSlice";

const { clearMessages } = userSlice;

export default function Login() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const messages = useSelector((state) => state.user.messages);

  useEffect(() => {
    if (user) {
      navigate("/main");
    }
  }, [navigate, user]);

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [message, setMessage] = useState({
    type: "",
    message: "",
  });

  useEffect(() => {
    setLoginData({
      email: "",
      password: "",
    });
    setMessage({
      type: "",
      message: "",
    });
    dispatch(clearMessages());
  }, [dispatch, location]);

  useEffect(() => {
    setMessage(...messages);
  }, [messages]);

  const changeLoginData = (event) => {
    setMessage({
      type: "",
      message: "",
    });
    setLoginData((prev) => ({
      ...prev,
      [event.target.id]: event.target.value,
    }));
  };

  const handleLoginButton = () => {
    if (loginData.email && loginData.password) {
      dispatch(
        loginUser({ login: loginData.email, password: loginData.password })
      );
    } else {
      if (!!loginData.email.length || !!loginData.password.length) {
        setMessage({
          type: "error",
          message: "Не введены логин или пароль",
        });
      }
    }
  };

  return (
    <div>
      <div className="main_block_login">
        <div className={"login_form"}>
          <Box
            component="form"
            onChange={(event) => changeLoginData(event)}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Typography
              sx={{ color: "white", fontSize: "18px", fontWeight: "bold" }}
            >
              Авторизация
            </Typography>
            <TextField
              id="email"
              label="Email"
              variant="filled"
              sx={{ bgcolor: "white", width: "80%" }}
              value={loginData.email || ""}
            />
            <TextField
              id="password"
              label="Пароль"
              variant="filled"
              type="password"
              sx={{ bgcolor: "white", width: "80%" }}
              value={loginData.password || ""}
            />
            <Box>
              <Link to={"/reset"} style={{ textDecoration: "none" }}>
                <Typography sx={{ color: "white", cursor: "pointer" }}>
                  Забыли пароль?
                </Typography>
              </Link>
            </Box>
            {message?.message ? (
              <Box sx={{ color: "white" }}>{message.message}</Box>
            ) : null}
            <Button
              variant="contained"
              onClick={() => handleLoginButton(loginData)}
            >
              Войти
            </Button>
          </Box>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
}
